import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import { ThemeProvider } from './theme/ThemeContext';
import { AuthProvider, useAuth } from './auth/AuthContext';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Clients from './components/Clients';
import Devis from './components/Devis';
import Factures from './components/Factures';
import Couts from './components/Couts';
import CoutsStructure from './components/CoutsStructure';
import Regroupements from './components/Regroupements';
import Tva from './components/Tva';
import './styles/index.css';

/* Ne monte l'application que lorsque la session est valide. */
const Gate = () => {
  const { status } = useAuth();

  if (status === 'loading') {
    return <div className="loading">Connexion au serveur…</div>;
  }

  if (status === 'anon') {
    return <Login />;
  }

  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="devis" element={<Devis />} />
            <Route path="factures" element={<Factures />} />
            <Route path="couts" element={<Couts />} />
            <Route path="couts-structure" element={<CoutsStructure />} />
            <Route path="tva" element={<Tva />} />
            <Route path="regroupements" element={<Regroupements />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
